export class Brand {
	id?: number;
	name?: string;

	constructor(init?: Partial<Brand>) {
		Object.assign(this, init);
	}
}
